export const handlerReports = [
  {
    reportNumber: "0",
    report: "Handler Search (Advanced)",
    description:
      "Search for a Handler by ID Number, name, address, status, ID Type, etc.",
    url: "/reports/advanced-handler-search",
  },
  {
    reportNumber: "1",
    report: "Transporter Profile",
    description:
      "Search for a Transporter by name, address, registration number, or status to view Transporter Registration details.",
    url: "/reports/transporter",
  },
  {
    reportNumber: "2",
    report: "Hazardous Waste Handler Summary",
    description:
      "Provides a Manifest Summary, Tonnage by Waste Code and Tonnage by Method Code for a specified ID Number and year.",
    url: "/reports/hazardous-waste-summary",
  },
  {
    reportNumber: "3",
    report: "Large Quantity Generators",
    description:
      "Provides a list of Large Quantity Generators (LQGs) per year with their qualifying month and tonnage, aggregated from data acquired from manifests.",
    url: "/reports/large-quantity-generators-report",
    isRegulatory: true,
  },
  {
    reportNumber: "4",
    report: "Entity Association with a Specific Waste",
    description:
      "Provides a list of ID Numbers and the amount of waste in tons handled for a specified year, waste code, and entity type.",
    url: "/reports/entities-by-waste",
    isRegulatory: true,
  },
  {
    reportNumber: "5",
    report: "Tanner Report",
    description:
      "Provides Generator and Receiving Facility information with a summary of Hazardous Waste Manifest data for a specified year.",
    url: "/reports/tanner-report",
    isRegulatory: false,
  },
  {
    reportNumber: "6",
    report: "Tanner Report (CDTFA)",
    description:
      "This report consists of summary and tonnage information for active hazardous waste generators during a specified year. Includes Manifests containing Chemicals of Interest.",
    url: "/reports/tanner-report-regulatory",
    isRegulatory: true,
  },
  {
    reportNumber: "7",
    report: "Entities Which Interface",
    description:
      "Provides a list of hazardous waste handlers which interfaced with a specified ID number within a specified date range. The report returns entity type, ID number, name, county, manifest count,  and total tons.",
    url: "/reports/entities-which-interface-report",
    isRegulatory: true,
  },
  {
    reportNumber: "8",
    report: "Quarterly ID Number Export (CDTFA)",
    description:
      "Provides a fixed width text file of ID numbers issued within a specified date range.",
    url: "/reports/quarter-facility-export-report",
    isRegulatory: true,
  },
  {
    reportNumber: "9",
    report: "Notification of LQG Site Closure",
    description:
      "Provides a list of LQGs which have site closure notifications",
    url: "/reports/large-quantity-generator-closure-report",
    isRegulatory: true,
  }
];

export const tonnageReports = [
  {
    reportNumber: "3",
    report: "Find Manifests",
    description:
      "This report provides a summary of manifest information including days in transit. Search for manifest data by ID Number, Manifest Number, Entity Type, and Ship Year.",
    url: "/reports/manifest",
  },
  {
    reportNumber: "4",
    report: "Yearly Tonnage Report",
    description:
      "Provides total yearly tonnage by Entity Type, Method Code, or Waste Code.",
    url: "/reports/tonnage",
  },
  // {
  //   reportNumber: "6",
  //   report: "Tonnage By Non-RCRA Waste Code",
  //   description:
  //     "Provides the total tonnage of one or all Non-RCRA waste codes generated by a single EPAID for a specified date range or year.",
  //   url: "/reports/tonnage-by-waste",
  //   isRegulatory: true,
  // },
  // {
  //   reportNumber: "7",
  //   report: "Tonnage By RCRA Waste Code",
  //   description:
  //     "Provides the total tonnage of one or all RCRA waste codes generated by a single EPAID for a specified date range or year.",
  //   url: "/reports/tonnage-by-rcra-waste",
  //   isRegulatory: true,
  // },
  // {
  //   reportNumber: "8",
  //   report: "Tonnage by Disposal Method",
  //   description:
  //     "Provides the total tonnage of one or all disposal methods generated by a single EPAID for a specified date range or year.",
  //   url: "/reports/tonnage-by-disposal",
  //   isRegulatory: true,
  // },
  {
    reportNumber: "9",
    report: "Manifests with Corrections",
    description:
      "Provides a list of manifests where a correction was made to the original data submission for a specified ship year.",
    url: "/reports/correction-letter-manifest-report",
    isRegulatory: true,
  },
  {
    reportNumber: "12",
    report: "Shipments By Waste Code",
    description:
      "Provides a list of manifests for a specified ID Number, Entity Type, Ship Year and Waste Code.",
    url: "/reports/shipments-by-waste",
    isRegulatory: true,
  },
  {
    reportNumber: "14",
    report: "Generator Waste Summary by Region",
    description: "Provides a list of hazardous waste generators, ID number profile information, and the amount of waste generated for a specified region and date range.",
    url: "/reports/cupa-export-csv",
    isRegulatory: true,
  },
  {
    reportNumber: "15",
    report: "Waste Code By Year Matrix Report",
    description: "Detailed report of tonnage for waste codes per year.",
    url: "/reports/waste-code-matrix",
    isRegulatory: true,
  },
  {
    reportNumber: "16",
    report: "TQR Detail Report by Manifest",
    description: "This report returns data from the Transporter Quarterly Report (TQR) submissions by hazardous waste transporters operating under the consolidated manifesting procedure.  This report returns the Generator ID Number and detailed waste information from each receipt used in conjunction with a consolidated manifest for a specified date range, city or county.",
    url: "/reports/tqr-detail-report",
    isRegulatory: true,
  },
  {
    reportNumber: "17",
    report: "Historical Manifests Report",
    description: "Provides a list of historical manifests shipped prior to the year 2000.",
    url: "/reports/historical-manifests-report",
    isRegulatory: true,
  },
];

export const transporterReports = [
  {
    reportNumber: "1",
    report: "Transporters With High Transit Days",
    description:
      "Provides a list of transporters with high transit days for a specified Ship Year.",
    url: "/reports/transporters-with-high-transit-days",
    isRegulatory: true,
  },
  {
    reportNumber: "2",
    report: "Transporter Days In Transit",
    description:
      "Provides the manifest tracking number, shipment date, receipt date, breakdown of transporters (up to 8 per manifest) and number of days spent in transit during the transportation of the hazardous waste to the TSDF. Search by manifest number or transporter ID number and date range.",
    url: "/reports/days-in-transit-report",
    isRegulatory: true,
  },
  {
    reportNumber: "3",
    report: "Transporter Waste Detail",
    description:
      "Provides on the type(s) and amount of hazardous waste shipped on a manifest. Search by manifest number or ID number and date range.",
    url: "/reports/transporter-waste-detail-report",
    isRegulatory: true,
  },
  // {
  //   reportNumber: "4",
  //   report: "Transporter Summary",
  //   description:
  //     "Summary report of transporter waste.",
  //   url: "/reports/transporter-calc-report",
  //   isRegulatory: true,
  // },
  {
    reportNumber: "5",
    report: "TQR Submitted By Transporter",
    description:
      "Provides a list of Transporter Quarterly Report (TQR) submissions by Transporter for a given quarter.",
    url: "/reports/tqr-submissions-report",
    isRegulatory: true,
  },
]


export const otherReports = [
  {
    reportNumber: "1",
    report: "ArcGIS Dot Density Test",
    description: "ArcGis JS API Dot Density Test Page",
    url: "/reports/dot-density-test",
  },
  {
    reportNumber: "2",
    report: "ArcGIS Facilities Search Map",
    description: "ArcGis JS API Search Map",
    url: "/reports/facilities-search-map-test",
  },
  {
    reportNumber: "3",
    report: "ArcGIS Active Facilities Map",
    description: "ArcGIS JS API Map of Active HWTS Facilities",
    url: "/reports/search-active-test",
  },
  {
    reportNumber: "4",
    report: "ArcGIS HWTS Feature Map",
    description:
      "ArcGIS JS API Map of HWTS Facilities displayed using a FeatureService",
    url: "/reports/hwts-feature-map-test",
  },
  {
    reportNumber: "5",
    report: "Metabase Embed Test Page",
    description: "Test page for Embedding Metabase Component",
    url: "/MetabaseTest",
  },
  {
    reportNumber: "6",
    report: "HWTS Active vs Inactive Facilities with CES (Map)",
    description:
      "Map of all HWTS Facilities divided into Active and Inactive groups. Includes CalEnviroscreen layer.",
    url: "/maps/hwts-active-inactive-map",
  },
  {
    reportNumber: "7",
    report: "HWTS Halogenated Generators (ESRI Experience Builder Embed Test)",
    description:
      "Map of all HWTS Halogenated Generators inside of an ESRI Experience Builder UI.",
    url: "/maps/arcgis-experience-builder-test-map",
  },
  {
    reportNumber: "8",
    report: "Permanent State ID Confirmation Letters",
    description: "Provides a list of permanent state IDs and their confirmation letters.",
    url: "/reports/confirm-letters",
    isRegulatory: true
  }
];
